<template>
  <div>
    <activity-list v-show="tabType === 1" @handleShow="handleShow" />
    <activity-show v-if="tabType === 2" :rowItem="rowItem" @handleShow="handleShow"  />
    <!-- <activity-export v-if="tabType === 3" :rowItem="rowItem" /> -->
  </div>
</template>

<script>
import activityList from './list.vue'
import activityShow from './show.vue'
// import activityExport from './export.vue'
export default {
  components: { activityList, activityShow },
  data() {
    return {
      tabType: 1,
      rowItem: null
    }
  },
  methods: {
    handleShow(row, type) {
      this.rowItem = { ...row }
      this.tabType = type
    }
  }


}
</script>

<style>
</style>